import { StatColumn, StatProps } from "@bridgesplit/ui";
import { NeighboringPercentageDisplay } from "app/components/common";
import { getUnixTs } from "@bridgesplit/utils";
import { getVaultTvl } from "@bridgesplit/abf-react";
import { COPY } from "app/constants";

import { useVaultContext } from "../../VaultContext";

export default function CapStats() {
    const { vaultExpanded } = useVaultContext();
    const principalMetadata = vaultExpanded?.principalMetadata;
    const tvl = getVaultTvl(vaultExpanded, getUnixTs());

    const stats: StatProps[] = [
        {
            value: (
                <NeighboringPercentageDisplay
                    amountMaximum={vaultExpanded?.vaultStrategy.terms.supplyCaps?.maxOutstanding ?? null}
                    metadata={principalMetadata}
                    amount={tvl ?? 0}
                    nullText={COPY.NO_LIMITS}
                />
            ),
            caption: "Max TVL"
        },
        {
            value: (
                <NeighboringPercentageDisplay
                    amountMaximum={vaultExpanded?.vaultStrategy.terms.borrowCaps?.maxOutstanding ?? null}
                    metadata={principalMetadata}
                    amount={vaultExpanded?.vaultStrategy.strategy.currentDeployedAmount ?? 0}
                    nullText={COPY.NO_LIMITS}
                />
            ),
            caption: "Max borrow"
        }
    ];

    return <StatColumn loading={!vaultExpanded} stats={stats} />;
}
